import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config";
import "./AuthTheme.css";
import { BsEnvelopePaperFill, BsCheckCircleFill, BsXCircleFill, BsArrowLeft } from "react-icons/bs";

export default function VerifyEmail() {
  const [message, setMessage] = useState("Verifying your email…");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const attemptedRef = useRef(false);
  const [resendEmail, setResendEmail] = useState("");
  const [resending, setResending] = useState(false);
  const [resendMsg, setResendMsg] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setMessage("Invalid or missing verification token.");
      setStatus("error");
      return;
    }
    if (attemptedRef.current || isVerified) return;
    attemptedRef.current = true;

    axios
      .get(`${API_BASE_URL}/verify-email?token=${token}`)
      .then(() => {
        setMessage("Your email is verified! Choose a plan to activate your account.");
        setStatus("success");
        setIsVerified(true);
        setTimeout(() => navigate("/login?next=plans"), 3000);
      })
      .catch((error) => {
        console.error("Verification Failed:", error.response?.data || error);
        setMessage("That link is invalid or expired. Enter your email and we'll send a fresh one.");
        setStatus("error");
      });
  }, [navigate, isVerified]);

  const icon = status === "success" ? <BsCheckCircleFill /> : status === "error" ? <BsXCircleFill /> : <BsEnvelopePaperFill />;

  return (
    <div className="pf-auth pf-auth--center">
      <div className="pf-shell">
        <div className="pf-card">
          <div className="pf-card-icon"
            style={status === "success" ? { color: "#7de8a8", background: "rgba(37,211,102,.12)", borderColor: "rgba(37,211,102,.35)" }
              : status === "error" ? { color: "#ff9a9a", background: "rgba(239,68,68,.12)", borderColor: "rgba(239,68,68,.35)" } : undefined}>
            {icon}
          </div>
          <div>
            <h1 className="pf-title">Email verification</h1>
            <p className="pf-sub">{message}</p>
          </div>

          {status === "error" && (
            <>
              <div className="pf-field">
                <label htmlFor="ve-email">Email</label>
                <input id="ve-email" className="pf-input" type="email" placeholder="you@company.com"
                  value={resendEmail} onChange={(e) => setResendEmail(e.target.value)} />
              </div>
              {resendMsg && <div className="pf-msg pf-msg--ok">{resendMsg}</div>}
              <button className="pf-btn" disabled={resending || !resendEmail} onClick={async () => {
                setResending(true); setResendMsg("");
                try {
                  const res = await axios.post(`${API_BASE_URL}/resend-verification`, { email: resendEmail });
                  setResendMsg(res.data.message || "Sent! Check your inbox.");
                } catch (err) {
                  setResendMsg(err.response?.data?.error || "Failed to resend.");
                } finally { setResending(false); }
              }}>{resending ? "Sending…" : "Resend verification"}</button>
              <button className="pf-btn pf-btn--ghost" onClick={() => navigate("/login")}
                style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <BsArrowLeft /> Back to sign in
              </button>
            </>
          )}

          {status === "success" && (
            <button className="pf-btn" onClick={() => navigate("/login?next=plans")}>Choose a plan</button>
          )}
        </div>
      </div>
    </div>
  );
}
